import { Image, Menu } from "antd"
import Sider from "antd/es/layout/Sider"
import { useEffect, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { t } from "../../languages/i18n"
import { getFilteredMenuItems } from "./menuItems"
interface MenuItem {
  key: string
  label: string
  path?: string
  permissionKey?: string
  parent?: string
  hasPermission?: boolean
  children?: MenuItem[]
}

export const LayoutSider = ({ collapsed, language }: { collapsed: boolean; language: string }) => {
  const navigate = useNavigate()
  const location = useLocation()
  const originalMenuItems = getFilteredMenuItems()
  const [menuItems, setMenuItems] = useState(originalMenuItems)

  useEffect(() => {
    const updatedMenuItems = originalMenuItems.map(item => ({
      ...item,
      label: t(item?.label ?? ""),
      children: item.children?.map(child => ({
        ...child,
        label: t(child?.label ?? ""),
        key: child.key,
      })),
    })) as MenuItem[]

    setMenuItems(updatedMenuItems)
  }, [language])
  return (
    <Sider trigger={null} theme="light" breakpoint="lg" width={220} collapsible collapsed={collapsed}>
      <div
        style={{
          height: 70,
          textAlign: "center",
          width: "100%",
          display: "flex",
          justifyItems: "center",
          alignItems: "center",
          padding: "0 1rem",
        }}
      >
        {collapsed ? (
          <div style={{ display: "flex", alignItems: "center" }}>
            <Image
              src="/images/logocms.webp"
              preview={false}
              alt="logo"
              style={{ height: "32px", width: "32px", borderRadius: "99px", marginRight: "20px" }}
            />
          </div>
        ) : (
          <div style={{ display: "flex", alignItems: "center" }}>
            <Image
              src="/images/logocms.webp"
              preview={false}
              alt="logo"
              style={{ height: "32px", width: "32px", borderRadius: "99px", marginRight: "20px" }}
            />
            <p style={{ fontSize: "16px", color: "#333", fontWeight: 600 }}>DANBI CMS</p>
          </div>
        )}
      </div>

      <Menu
        mode="inline"
        theme="light"
        // @ts-ignore
        items={menuItems.map(item => ({
          ...item,
          children: item.children?.map(child => ({
            ...child,
          })),
        }))}
        onClick={info => {
          navigate(info.key)
        }}
        selectedKeys={[location.pathname]}
        className="custom-menu"
        style={{ minWidth: 0, flex: "auto" }}
      />
    </Sider>
  )
}
